import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import './styles/main.css';
import './index.css';
import { Provider as ReduxProvider } from 'react-redux';

const Provider = ReduxProvider as unknown as React.FC<React.PropsWithChildren<{ store: any }>>;
import localForage from 'localforage';
import allSettled from 'promise.allsettled';
import App from './App';
import configureStore from './store';
import * as serviceWorker from './serviceWorker';
import './pendoScript';

allSettled.shim();

localForage.config({
    name: `${process.env.REACT_APP_INDEXED_DB_NAME}`,
    description: `${process.env.REACT_APP_INDEXED_DB_DESCRIPTION}`,
    version: parseInt(`${process.env.REACT_APP_INDEXED_DB_VERSION}`, 10),
    storeName: `${process.env.REACT_APP_INDEXED_DB_STORE_NAME}`,
});

Sentry.init({
    dsn: `${process.env.REACT_APP_SENTRY_ENDPOINT}`,
    integrations: [new Integrations.BrowserTracing()],
    environment: `${process.env.REACT_APP_ENV}`,
    tracesSampleRate: 1.0,
});

async function renderApp() {
    const store = await configureStore();
    const container = document.getElementById('root');
    if (!container) return;
    const root = createRoot(container);
    root.render(
        <Provider store={store}>
            <App />
        </Provider>,
    );
}

renderApp();

serviceWorker.register();
